import { render, staticRenderFns } from "./editContent.vue?vue&type=template&id=546385a8&scoped=true&"
import script from "./editContent.vue?vue&type=script&lang=js&"
export * from "./editContent.vue?vue&type=script&lang=js&"
import style0 from "./editContent.vue?vue&type=style&index=0&id=546385a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546385a8",
  null
  
)

export default component.exports